// extracted by mini-css-extract-plugin
export default {"description-text":"Description_description-text__mOD4G","heading":"Description_heading__4ve-Q"};